<template>
  <card title="Agency">
    <!--
      The agency id input must render even when the clinic has no link yet:
      `clinicAgency` is null for an unlinked clinic, and gating the input on it
      removed the only way to attach an EXISTING agency (regression in b1eaffa).
      Only the resolved-agency details below depend on `clinicAgency`.
    -->
    <base-input
      :disabled="!canManageAgencies"
      label="Agency ID (bookimed.agencies_clinics)"
      type="number"
      v-model="agencyId"
      placeholder="Agency ID">
    </base-input>
    <div v-if="clinicAgency" class="agency-info mb-2">
      <div><strong>Name (EN):</strong> {{ clinicAgency.name_en || '—' }}</div>
      <div><strong>Country:</strong> {{ clinicAgency.country_code || '—' }}</div>
      <div>
        <strong>Status:</strong>
        <el-tag :type="clinicAgency.hide ? 'danger' : 'success'" size="mini" effect="dark">
          {{ clinicAgency.hide ? 'Inactive' : 'Active' }}
        </el-tag>
      </div>
    </div>
    <small v-if="clinicAgencyIds.length > 1" class="text-muted d-block mb-2">
      Clinic is linked to several agencies: {{ clinicAgencyIds.join(', ') }}.
      Saving replaces only the one shown above.
    </small>
    <base-button v-if="canManageAgencies" type="primary" size="sm" :disabled="!isDirty" @click="save()">
      Save agency
    </base-button>

    <div v-if="canManageAgencies" class="clinic-agency__add-partner">
      <base-button type="info" size="sm" @click="openAddPartnerModal()">
        Add partner
      </base-button>
    </div>

    <AddPartnerModal :show.sync="isAddPartnerModalVisible" :clinic-id="clinic.id"/>
  </card>
</template>

<script>
import agencyAccess from '@/components/Agencies/agencyAccess';
  import { mapState, mapActions } from 'vuex';
  import AddPartnerModal from '@/components/Clinics/AddPartnerModal';

  export default {
  mixins: [agencyAccess],
    components: {
      AddPartnerModal,
    },
    data() {
      return {
        agencyId: null,
        previousAgencyId: null,
        isAddPartnerModalVisible: false,
      };
    },
    computed: {
      ...mapState('clinics', ['clinic']),
      ...mapState('clinicAgency', ['clinicAgencyId', 'clinicAgencyIds', 'clinicAgency']),
      isDirty() {
        return this.normalize(this.agencyId) !== this.normalize(this.previousAgencyId);
      },
    },
    created() { this.$store.dispatch('agencies/refreshPermissions');
      this.load();
    },
    methods: {
      ...mapActions('clinicAgency', ['getClinicAgency', 'saveClinicAgency']),
      normalize(value) {
        const num = parseInt(value, 10);
        return Number.isNaN(num) ? null : num;
      },
      async load() {
        await this.getClinicAgency(this.clinic.id);
        this.agencyId = this.clinicAgencyId;
        this.previousAgencyId = this.clinicAgencyId;
      },
      save() {
        if (!this.canManageAgencies) return;
        this.$store.dispatch('setLoader', true);
        return this.saveClinicAgency({
          clinicId: this.clinic.id,
          agencyId: this.normalize(this.agencyId),
          previousAgencyId: this.normalize(this.previousAgencyId),
        })
          .then(() => this.load())
          .then(() => this.$notify({ type: 'success', title: 'Agency saved' }))
          .catch(() => this.$notify({ type: 'warning', title: 'Save Failed' }))
          .finally(() => this.$store.dispatch('setLoader', false));
      },
      openAddPartnerModal() {
        if (!this.canManageAgencies) return;
        this.isAddPartnerModalVisible = true;
      },
    },
  }
</script>

<style lang="scss" scoped>
  .clinic-agency {
    &__add-partner {
      display: block;
      margin-top: 20px;
    }
  }
</style>
